import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Card, Button, Alert } from 'react-bootstrap';

const CheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || 'tu correo electrónico';

  return (
    <div 
      className="min-vh-100 d-flex align-items-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="shadow-lg border-0" style={{ maxWidth: '600px', width: '100%' }}>
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <img 
                  src="/LOGO-DIRESA.png" 
                  alt="Logo DIRESA" 
                  className="mb-3"
                  style={{ maxHeight: '80px', width: 'auto' }}
                />
                <div className="mb-4" style={{ fontSize: '4rem' }}>
                  📧
                </div>
                <h2 className="fw-bold text-primary mb-3">¡Revisa tu Correo Electrónico!</h2>
                <p className="text-muted fs-5">
                  Te hemos enviado un enlace de verificación a
                </p>
                <p className="fw-bold text-primary fs-5 mb-4">{email}</p>
              </div>

              <Alert variant="info" className="mb-4">
                <Alert.Heading className="d-flex align-items-center">
                  <i className="bi bi-info-circle-fill me-2"></i>
                  Instrucciones
                </Alert.Heading>
                <ol className="mb-0 ps-3">
                  <li className="mb-2">Abre tu bandeja de entrada de correo electrónico</li>
                  <li className="mb-2">Busca el correo de "Sistema de Cotizaciones DIRESA"</li>
                  <li className="mb-2">Haz clic en el botón "Verificar Correo Electrónico" o copia el enlace</li>
                  <li className="mb-2">Una vez verificado, podrás iniciar sesión en el sistema</li>
                </ol>
              </Alert>

              <Alert variant="warning" className="mb-4">
                <Alert.Heading className="d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  ¿No recibiste el correo?
                </Alert.Heading>
                <p className="mb-2">Revisa tu carpeta de spam o correo no deseado.</p>
                <p className="mb-0">Si aún no lo recibes, espera unos minutos y verifica nuevamente.</p>
              </Alert>

              <div className="text-center">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={() => navigate('/login')}
                  className="me-2 mb-2"
                >
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Ir a Iniciar Sesión
                </Button>
                <Button 
                  variant="outline-secondary" 
                  size="lg"
                  onClick={() => navigate('/')}
                  className="mb-2"
                >
                  <i className="bi bi-house me-2"></i>
                  Volver al Inicio
                </Button>
              </div>

              <div className="text-center mt-4">
                <p className="text-muted small mb-0">
                  <i className="bi bi-clock me-1"></i>
                  El enlace de verificación expira en 24 horas
                </p>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default CheckEmail;

